/**
 * @class msvcSkGIS
 * @description Custom service for SK mOffice to load translations of GIS regions/districts/municipalities.
 * Receives definitions from msvrSkGIS.
 * Creates translations:
 * - skgis.region.{region_code} for regions
 * - skgis.district.{district_code} for districts
 * - skgis.municipality.{municipality_code} for municipalities
 */

import msysListener from 'msysListener'

export default class msvcSkGIS extends msysListener {
  constructor(id, cfg, cfg_schema, dependencies) {
    dependencies = _.union(['msysLogger'], dependencies)
    cfg_schema = _.extend({
      server: { description: 'server to obtain GIS definitions from', type: 'string', default: ':msvrSkGIS' },
      prefix: { description: 'prefix for translation keys', type: 'string', default: 'skgis.' },
    }, cfg_schema)
    super(id, cfg, cfg_schema, dependencies)
    this.loaded = false
  } // constructor

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * @description
   * msysDomainClient informs all listeners that connection to mServer is established
   * @param {object} sender - message sender
   * @param {object} params - message parameters
   * @param {string} [params.app_id] - app_id of the server
   * @param {string} params.url - URL of connected server
   * @param {string} [params.ident] - Identity string of server
   * @param {string} [params.client_ip] - IP of the client as recognized by the server
   */
  async mmServerConnected(sender, params) {
    if(this.loaded) return
    try{
      const reply = await this.request(this.config.server, 'mmFetch', {}, 'mmData')
      const regions = reply.params.data.regions
      LANG.createOptions(this.config.prefix + 'region.', { '': LANG.ZERO_SPACE, ...regions }, true)
      const districts = reply.params.data.districts
      LANG.createOptions(this.config.prefix + 'district.', { '': LANG.ZERO_SPACE, ...districts }, true)
      const municipalities = reply.params.data.municipalities
      LANG.createOptions(this.config.prefix + 'municipality.', { '': LANG.ZERO_SPACE, ...municipalities }, true)
    }catch(error) {
      this.error('Error fetching GIS definitions from server:', error)
    }
    this.loaded = true
  } // mmServerConnected
} // msvcSkGIS
